import { gql } from '@apollo/client';

export const DAILY_TIPS_QUERY = gql`
  query DailyTipsDaily($date: Date, $filter: DailyTipsFilter) {
    dailyTipsDaily(date: $date, filter: $filter) {
      date
      total_tips
      tips {
        id
        tip_date
        rank
        description
        units
        bet_type
        meeting {
          meeting_id
          meeting_date
          track_id
          race_count
          status
          is_private
          is_training
          meeting_note
          meeting_note_type
          created_at
          updated_at
          track {
            track_id
            name
            code
            state
            type
            created_at
            updated_at
          }
        }
        race {
          race_id
          meeting_id
          race_number
          race_name
          distance
          race_time
          status
          created_at
          updated_at
        }
        runner {
          runner_id
          race_id
          horse_id
          tab_number
          barrier
          horse_name
          jockey
          trainer
          weight
          created_at
          form_data {
            form_data
          }
          result {
            position
            position_finish
            horse_name
            barrier
            horse_number
            price_sp
          }
        }
        analysis {
          analysis_id
          horse_id
          horse_name
          odds
          assessed_odds
          adjusted_assessed_prob
          confidence
          analysis_summary
          pros
          cons
          pick_order
          pick_type
          bet_stake
          bet_type
          version
          is_latest
          created_at
        }
        created_at
        updated_at
      }
      meetings {
        meeting_id
        track_id
        meeting_date
        race_count
        status
        is_private
        is_training
        meeting_note
        meeting_note_type
        created_at
        updated_at
        track {
          track_id
          name
          code
          state
          type
          created_at
          updated_at
        }
        trackConditions {
          weather
          trackCondition
          trackConditionNumber
          penetrometer
          rail
          lastUpdate
          abandoned
        }
        predictedTrackConditions {
          predictedWeather
          predictedTrackCondition
          predictedTrackConditionNumber
          predictedPenetrometer
          predictionConfidence
          predictionDate
        }
      }
      content {
        id
        meeting_date
        heading
        content
        created_at
        updated_at
      }
      scratchings {
        raceNo
        tabNo
        runnerId
        runnerName
        reason
        scratched_at
      }
    }
  }
`;